import * as Yup from 'yup';

export const loginValidate = Yup.object().shape({
  email: Yup.string()
    .required('This field in required!'),
  password: Yup.string()
  .required('This field in required!'),
});